import { SelectionModel } from '@angular/cdk/collections';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Input, Output, ViewChild, AfterViewInit, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ModalNovoFreteDedicadoComponent } from 'src/app/@feature/cadastro/cadastros/frete/frete-dedicado/modal-novo-frete-dedicado/modal-novo-frete-dedicado.component';
import { ModalConfirmacaoComponent } from 'src/app/@shared/components/modal-confirmacao/modal-confirmacao.component';
import { 
  AlterarEntidadeRequest,
  AprovacaoCteResponse,
  DeletarPedidoAgrupamentoRequest,
  DeletarPedidoAgrupamentoResponse,
  EtapaCte,
  ListarDetalheCteRequest,
  ListarDetalheCteResponse,
  PedidosRelacionadosCte,
  ReprocessarCteResponse
} from 'src/app/@shared/models/manifesto-embarque-painel-cte.model';
import { ImpressaoManifestoService } from 'src/app/services/impressao-manifesto/impressao-manifesto.service';
import { ManifestoEmbarquePainelCteService } from 'src/app/services/manifesto-embarque-painel-cte/manifesto-embarque-painel-cte.service';
import { PainelCteModalEntidadeComponent } from '../painel-cte-modal-entidade/painel-cte-modal-entidade.component';

// declare var require: any
// const FileSaver = require('file-saver');

@Component({
  selector: 'app-painel-cte-detalhe',
  templateUrl: './painel-cte-detalhe.component.html',
  styleUrls: ['./painel-cte-detalhe.component.scss']
})
export class PainelCteDetalheComponent implements OnInit, AfterViewInit {
  @Input() objetoCTe: ListarDetalheCteRequest;
  @Output("removerTab") removerTab: EventEmitter<any> = new EventEmitter();

  isLoading: boolean;
  loadingWhileDownload: boolean;
  detalhesCte: any;
  etapas: EtapaCte[];

  canceladoOuErro: boolean;
  podeReprocessar: boolean;
  podeCriarRota: boolean;
  temErroCteNfe: boolean;
  regraEspecialAprovacao: boolean;

  displayedColumns: string[] = [
    'select',
    'pedido',
    'chaveCTe',
    'chaveNFe'
  ];

  // public paging = { index: 0, size: 10, length: 0 };
  dataSource = new MatTableDataSource<PedidosRelacionadosCte>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pedidosSelecionados = new SelectionModel<any>(true, []);

  constructor(
    private painelCteService: ManifestoEmbarquePainelCteService,
    public impressaoService: ImpressaoManifestoService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog
    ) { }
    
  ngOnInit() {
    this.consultarDetalheCte();
  }
  
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  consultarDetalheCte() {
    this.isLoading = true;
    this.dataSource.data = [];
    this.painelCteService.listarDetalheCte(this.objetoCTe).subscribe(
      (response: ListarDetalheCteResponse) => {
        this.detalhesCte = response;

        this.etapas = this.detalhesCte.etapas
          .filter((etapa: EtapaCte) => etapa.ordem !== -1)
          .sort((a, b) => a.ordem - b.ordem);
          
        this.dataSource.data = this.detalhesCte.pedidosRelacionados;

        this.canceladoOuErro = this.detalhesCte.etapas.filter(etapa =>
          (etapa.nome === 'Erro' || etapa.nome === 'Cancelando') && etapa.data
        ).length;

        this.pedidosSelecionados.clear();
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Documento não encontrado', 'OK', 3000);
      })
      .add(() => {
        this.isLoading = false;
        this.criarRota();
        this.reprocessar();
        this.regraEspecialParaAprovacao();
        this.erroCteNfe();
      })
  }

  podeEditarEntidade(entidade: string): boolean {
    return this.detalhesCte.erro.descricao.includes(entidade);
  }

  regraEspecialParaAprovacao(): void {
    const TipoProcessamentoEspecial = [5, 7, 8];
    this.regraEspecialAprovacao = 
      this.detalhesCte.statusId == 6 
      && TipoProcessamentoEspecial.includes(this.detalhesCte.tipoProcessamento);
  }

  reprocessar(): void {
    const status = [5, 8, 11, 12, 15, 16];
    this.podeReprocessar = status.includes(this.detalhesCte.statusId);
  }

  criarRota() {
    const { id, tipo } = this.detalhesCte.erro;

    if (tipo === 'basico' && [9, 84].includes(id)) {
      this.podeCriarRota = true;
    } else {
      this.podeCriarRota = false;
    }
  }

  erroCteNfe() {
    this.temErroCteNfe = this.detalhesCte.pedidosRelacionados
      .filter(pedido => !!pedido.errocte || !!pedido.erronfe).length
  }

  aprovacaoCte(aprovar: boolean) {
    this.isLoading = true;
    const obj = { 
      identificacaoId: this.objetoCTe.identificacaoId, 
      aprovacao: aprovar
    }

    this.painelCteService.aprovacaoCte(obj).subscribe(
      (response: AprovacaoCteResponse) => {
        if (response.linhasAfetadas === 0) {
          return this.openSnackBar(
            'Ação não realizada!',
            'ERROR',
            3000,
            'warning-snackbar'
          );
        } else {
          this.openSnackBar(`CTe ${(aprovar ? 'Aprovado' : 'Reprovado')} com sucesso!`, 'OK', 3000, 'success-snackbar');
          return this.removerTab.emit();
        }
      }
    )

  }

  reprocessarCte() {
    this.isLoading = true;

    const obj = { identificacaoId: this.objetoCTe.identificacaoId }

    this.painelCteService.reprocessarCte(obj).subscribe(
      (response: ReprocessarCteResponse) => {
        if (response.linhasAfetadas === 0) {
          return this.openSnackBar(
            'CTe não entra nos critérios de reprocessamento!',
            'OK',
            3000,
            'warning-snackbar'
          );
        } else {
          this.consultarDetalheCte();
          return this.openSnackBar('CTe reprocessado com sucesso!', 'OK', 3000, 'success-snackbar');
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Erro ao reprocessar CTe! Protocolo: ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  // download(tipo: string){
  //   // Download de PDF está gerando uma página para cada pedido dentro da CTE
  //   const obj = {
  //     "cTe": [
  //       {
  //         "tipo":"CTE",
  //         "codigo": this.detalhesCte.chaveCTe,
  //         "pedido":"0",
  //         "cTe": this.detalhesCte.chaveCTe
  //       }
  //     ],
  //     "nFe":[],
  //     "imprimiCapa":false,
  //     "imprimiSemCapa":true,
  //     "imprimiSomenteCapa":false,
  //     "imprimirCapaCodigoBarra":false
  //   };

  //   this.loadingWhileDownload = true;
  //   this.impressaoService[tipo === 'xml' ? 'downloadXML' : 'downloadPDF'](obj)
  //   .subscribe(response =>{
  //     const byteArray = this.base64ToArrayBuffer(response.item1);
  //     const blob: any = new Blob([byteArray], { type: 'application/octet-stream' });
  //     FileSaver.saveAs(blob, response.item2);
  //     this.loadingWhileDownload = false;
  //   }, error => {
  //     this.loadingWhileDownload = false;
  //     this.openSnackBar('Erro ao efetuar download!' + (error.error?.error || error.error), 'OK', 5000, 'danger-snackbar');
  //   });
  // }

  // base64ToArrayBuffer(base64: any): ArrayBuffer {
  //   var binary_string = window.atob(base64);
  //   var len = binary_string.length;
  //   var bytes = new Uint8Array(len);
  //   for (var i = 0; i < len; i++) {
  //     bytes[i] = binary_string.charCodeAt(i);
  //   }
  //   return bytes.buffer;
  // }

  isAllSelected() {
    const quantidadeSelecionado = this.pedidosSelecionados.selected.length;
    const quantidadeLinha = this.dataSource.data.length;
    return quantidadeSelecionado === quantidadeLinha;
  }

  masterToggle() {
    this.isAllSelected() 
      ? this.pedidosSelecionados.clear()
      : this.dataSource.data.forEach(pedido => {
          if (!!pedido.errocte || !!pedido.erronfe) this.pedidosSelecionados.select(pedido)
        });
  }

  removePedidoLista(pedido: PedidosRelacionadosCte) {
    const index = this.dataSource.data.indexOf(pedido)

    if (index !== -1) {
      this.pedidosSelecionados.deselect(this.dataSource.data[index]);
    } else {
      this.openSnackBar('Item não encontrado na seleção!', 'OK', 3000, 'warning-snackbar');
    }
  }

  removerPedidosSelecionados() { 
    const pedidos = this.pedidosSelecionados.selected
      .filter(pedido => !!pedido.errocte || !!pedido.erronfe)
      .map(pedido => pedido.pedidoId)

    const obj: DeletarPedidoAgrupamentoRequest = {
      idAgrupamento: this.pedidosSelecionados.selected[0].idAgrupamento,
      pedidos
    };

    this.painelCteService.deletarPedidoAgrupamento(obj).subscribe(
      (response: DeletarPedidoAgrupamentoResponse) => {
        if (response.linhasAfetadas === 0) {
          return this.openSnackBar(
            'CTe não entra nos critérios de reprocessamento!',
            'OK',
            3000,
            'warning-snackbar'
          );
        } else {
          this.openSnackBar(
            'Pedido(s) removido(s) do CTe com sucesso. CTe reprocessada!',
            'OK', 3000,
            'success-snackbar'
          );
          this.consultarDetalheCte();
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Erro ao remover pedido(s) do CTe! Protocolo: ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      }
    )
  }

  abrirModalEntidade(entidade: AlterarEntidadeRequest) {
    const objEntidade = Object.assign(
      {filial: this.objetoCTe.filial, numCTe: this.objetoCTe.numCTe}
      ,entidade
    )
    const dialogRef = this.dialog.open(PainelCteModalEntidadeComponent, {
      data: { objEntidade },
      disableClose: true,
      width: '720px'
    });

    dialogRef.afterClosed().subscribe(
      response => {
        if (response === 'sucesso') {
          this.consultarDetalheCte();
        }
      })
  }

  abrirModalCadastroFrete(rotaId: number) {
    const dialogRef = this.dialog.open(ModalNovoFreteDedicadoComponent, {
      disableClose: true,
      width: '750px',
      height: 'auto',
      data: { rotaId }
    });

    dialogRef.afterClosed().subscribe(
      response => {
        if (response === 'sucesso') {
          this.consultarDetalheCte();
        }
      });
  }

  modalConfirmacaoRemoverPedidos() {
    const pedidos = this.pedidosSelecionados.selected.map(pedido => pedido.pedidoId)

    const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
      width: '540px',
      data: {
        texto: `Confirma a exclusão do(s) pedido(s): ${pedidos}?`
      },
    });

    dialogRef.afterClosed().subscribe(
      async response => {
        if (response === 1) {
          this.removerPedidosSelecionados();
        }
      });
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
